module.exports = __webpack_public_path__ + "static/media/dentistryBanner.7ca5c240.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dentistryBanner.jpg
// module id = 494
// module chunks = 0